/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 9.75a.75.75 0 0 1 .75.75v6a.75.75 0 1 1-1.5 0v-6A.75.75 0 0 1 9 9.75Zm6.75.751a.75.75 0 0 0-1.5 0v6a.75.75 0 1 0 1.5 0v-6ZM12 9a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0v-7.5A.75.75 0 0 1 12 9Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.75 1.5A2.25 2.25 0 0 0 7.5 3.75v1.5H2.25a.75.75 0 0 0 0 1.5H4.5V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75h2.25a.75.75 0 0 0 0-1.5H16.5v-1.5a2.25 2.25 0 0 0-2.25-2.25h-4.5ZM15 5.25v-1.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v1.5h6Zm-9 1.5V19.5c0 .415.336.75.75.75h10.5a.75.75 0 0 0 .75-.75V6.75H6Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgDelete)
export default Memo
